import React from "react";

import Contact from "../components/Contact";

const ContactPage = () => {
  return (
    <div className="col-12 bg-light p-0">
      <div className="col-md-8 col-sm-10 mx-auto pb-4 pt-4">
        <Contact />
      </div>
    </div>
  );
};

export default ContactPage;
